import app from 'app';
import templateUrl from './settings.html';
import './settings.scss';

function SettingsCtrl($state, $transitions) {
  const Settings = this;

  Settings.$onInit = () => {
    Settings.isEdit = $state.current.data.isEdit;

    $transitions.onSuccess({ from: '*', to: '*' }, (transition) => {
      Settings.isEdit = transition.$to().data.isEdit;
    });
  };
}

app.component('settings', {
  controller: SettingsCtrl,
  controllerAs: 'Settings',
  templateUrl,
});

export default 'settings';
